import axios from "axios";
import React, { useEffect, useState } from "react";
import "../assests/Stylesheet/reports.css";
import { Navbar } from "../Components/allcomponents";
import BuilderReport from "../Reports/BuilderReport";
import Transaction from "../Reports/Transaction";

const Reports = () => {
  const [state, setState] = useState(1);
  const [FormList, setFormList] = useState([]);
  const GetForm = async () => {
    var data = JSON.stringify({
      dbname: "erp_eshiksa",
      Branch_id: localStorage.getItem("Branch_id"),
      tag: "studentFeesFormBuilder",
    });

    var config = {
      method: "post",
      url: "https://erpapi.eshiksa.net/FormBuilderFeesReport.php",
      headers: {
        "Content-Type": "application/json",
        Cookie:
          "AWSALB=MphD3em34Mp9mMamEw4Zt33VaZH7huNiL3KohM0xBZi17xCaud3cbKncfZ3LXXiLSlgeoYUaemirT4kT+amaSeQott9nUL0icSf07F8nMVYBvzt3fU22z+W6uF/f; AWSALBCORS=MphD3em34Mp9mMamEw4Zt33VaZH7huNiL3KohM0xBZi17xCaud3cbKncfZ3LXXiLSlgeoYUaemirT4kT+amaSeQott9nUL0icSf07F8nMVYBvzt3fU22z+W6uF/f",
      },
      data: data,
    };

    await axios(config)
      .then(function (response) {
        if (response.data.error !== 1) {
          setFormList(response.data.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    GetForm();
  }, []);

  return (
    <div className="">
      <Navbar />
      <div className="container h-100">
        <div className="row justify-content-around   my-3 ">
          <div
            onClick={() => setState(1)}
            className={`col-sm-5 card mx-2 my-1 text-center report-card p-4 ${
              state === 1 && "active"
            }`}
          >
            Form Builder Transaction Report
          </div>
          <div
            onClick={() => setState(2)}
            className={`col-sm-5 card mx-2 my-1 text-center report-card p-4 ${
              state === 2 && "active"
            }`}
          >
            Form Builder Report
          </div>
        </div>

        <main>{state === 1 && <Transaction list={FormList} />}</main>
        <main>{state === 2 && <BuilderReport />}</main>
      </div>
    </div>
  );
};

export default Reports;
